// ARVADA — mobile menu: parent items open in place (accordion).
// Runs in the capture phase so Dawn's header-drawer button handler (which closes submenus) never sees these clicks.
document.addEventListener('click', (event) => {
  const toggle = event.target.closest('[data-av-mm-toggle]');
  if (!toggle) return;
  event.stopPropagation();
  event.preventDefault();
  const panel = document.getElementById(toggle.getAttribute('aria-controls'));
  const open = toggle.getAttribute('aria-expanded') !== 'true';
  toggle.setAttribute('aria-expanded', String(open));
  if (panel) panel.hidden = !open;
}, true);
